import { render } from "./TemplatePreview.vue?vue&type=template&id=95b5918a&scoped=true"
import script from "./TemplatePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatePreview.vue?vue&type=script&setup=true&lang=js"

import "./TemplatePreview.vue?vue&type=style&index=0&id=95b5918a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b5918a"],['__file',"resources/js/components/whatsapp-managment/includes/TemplatePreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95b5918a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95b5918a', __exports__)) {
    console.log('reload')
    api.reload('95b5918a', __exports__)
  }
  
  module.hot.accept("./TemplatePreview.vue?vue&type=template&id=95b5918a&scoped=true", () => {
    console.log('re-render')
    api.rerender('95b5918a', render)
  })

}


export default __exports__